// utils/validationSchemas.js
import * as Yup from "yup"

const hoy = new Date()
const finDelDia = new Date(
  hoy.getFullYear(),
  hoy.getMonth(),
  hoy.getDate(),
  23, // horas
  59, // minutos
  59 // segundos
)

const nameRegex = /^[A-ZÑ]+(?: [A-ZÑ]+)*$/
const curpRegex =
  /^[A-Z]{4}\d{6}[HM][A-Z]{2}[ABCDFGHJKLMNPQRSTVWXYZ]{3}[A-Z0-9]{2}$/
const phoneRegex = /^\d{10}$/
const postalCodeRegex = /^\d{5}$/
const emailRegex = /^(?!.*@[^,]*,)/
const RegimenFiscalRegex = /^\d{3}$/
const RFCRegex =
  /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})?$/

//"Solo puede contener letras y un espacio entre palabras."
const genericoRegex = /^[A-ZÑ0-9 #.]*$/

export const loginValidationSchema = Yup.object({
  email: Yup.string().required("Escribe tu Correo Electrónico"),
  password: Yup.string().required("Escribe tu Contraseña"),
  id_colegio: Yup.number().min(1, "Selecciona un colegio válido"),
})

export const AltaAlumnoSchema = Yup.object({
  Apellido_Paterno: Yup.string()
    .max(255, "No puede exceder 255 caracteres.")
    .matches(
      nameRegex,
      "Solo puede contener letras y un espacio entre palabras."
    )
    .required("Requerido"),
  Apellido_Materno: Yup.string()
    .max(255, "No puede exceder 255 caracteres.")
    .matches(
      nameRegex,
      "Solo puede contener letras y un espacio entre palabras."
    ),
  Nombres: Yup.string()
    .max(255, "No puede exceder 255 caracteres.")
    .matches(
      nameRegex,
      "Solo puede contener letras y un espacio entre palabras."
    )
    .required("Requerido"),
  Curp: Yup.string()
    .length(18, "Debe tener 18 caracteres.")
    .matches(curpRegex, "Debe cumplir con el formato CURP.")
    .required("Requerido"),
  Email_Personal: Yup.string()
    .max(255, "No puede exceder 255 caracteres.")
    .email()
    .matches(emailRegex)
    .required("Requerido"),
  Password: Yup.string()
    .max(255, "No puede exceder 255 caracteres.")
    .min(6, "La longitud del password debe ser de al menos 6 caracteres.")
    .matches(RegExp("(.*[a-z].*)"), "Al menos una letra minúscula")
    .matches(RegExp("(.*[A-Z].*)"), "Al menos una letra mayúscula")
    .matches(RegExp("(.*[0-9].*)"), "Al menos un número")
    .required("Requerido"),
  Telefono_Celular: Yup.string()
    .matches(
      phoneRegex,
      "El teléfono debe tener exactamente 10 dígitos y solo números."
    )
    .required("Requerido"),
  id_Estado_Nacimiento: Yup.number().required("Requerido"),
  id_Pais_Nacimiento: Yup.number().required("Requerido"),
  Fecha_Nacimiento: Yup.date()
    .required("Requerido")
    .max(hoy, "La fecha no puede ser en el futuro"),
  id_Estado_Civil: Yup.number().required("Requerido"),
  // Dirección
  Calle: Yup.string()
    .max(250, "No puede exceder 250 caracteres.")
    .matches(
      genericoRegex,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
  Numero_Exterior: Yup.string()
    .max(10, "No puede exceder 10 caracteres.")
    .matches(
      genericoRegex,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
  Numero_Interior: Yup.string()
    .max(10, "No puede exceder 10 caracteres.")
    .matches(
      genericoRegex,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
  Colonia: Yup.string()
    .max(250, "No puede exceder 250 caracteres.")
    .matches(
      genericoRegex,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
  Municipio: Yup.string()
    .max(250, "No puede exceder 250 caracteres.")
    .matches(
      genericoRegex,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
  Poblacion: Yup.string()
    .max(250, "No puede exceder 250 caracteres.")
    .matches(
      genericoRegex,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
  Apartado_Postal: Yup.string().matches(
    genericoRegex,
    "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
  ),
  Atencion: Yup.string().matches(
    genericoRegex,
    "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
  ),
  Codigo_Postal: Yup.string().matches(
    postalCodeRegex,
    "El código postal debe tener cinco números."
  ),
  Telefono_Fijo: Yup.string().matches(
    phoneRegex,
    "El teléfono debe tener exactamente 10 dígitos y solo números."
  ),
  Telefono_Fijo2: Yup.string().matches(
    phoneRegex,
    "El teléfono debe tener exactamente 10 dígitos y solo números."
  ),
  Telefono_Fijo3: Yup.string().matches(
    phoneRegex,
    "El teléfono debe tener exactamente 10 dígitos y solo números."
  ),
  id_Estado: Yup.number()
    .required("Requerido")
    .positive("Debes elegir una opción"),
  id_Pais: Yup.number()
    .required("Requerido")
    .positive("Debes elegir una opción"),
  // Datos academicos
  //id_Alumno: -1,
  //id_Persona: -1,
  id_Campus: Yup.number()
    .required("Requerido")
    .positive("Debes elegir una opción"),
  id_Programa_Academico: Yup.number()
    .required("Requerido")
    .positive("Debes elegir una opción"),
  id_Plan_Estudio: Yup.number()
    .required("Requerido")
    .positive("Debes elegir una opción"),
  id_Status: Yup.number()
    .required("Requerido")
    .positive("Debes elegir una opción"),
  id_Turno: Yup.number()
    .required("Requerido")
    .positive("Debes elegir una opción"),
  //id_Turno_Extra: -1,
  id_Trayectoria: Yup.number()
    .required("Requerido")
    .positive("Debes elegir una opción"),
  //id_Kardex: -1,
  Fecha_Inscripcion: Yup.date()
    .required("Requerido")
    .max(finDelDia, "La fecha no puede ser en el futuro"),
  En_Proceso_Revalidacion_Materias: "",
  Fecha_Inscripcion_SE: Yup.date().required("Requerido"),
  Fecha_Inicio_Clases: Yup.date().required("Requerido"),
  // Este es el checkbox que determina si se muestran campos adicionales.
  requiereFactura: Yup.boolean(),
  // Campo que solo se valida si 'requiereFactura' es true.
  id_Contribuyente: Yup.number().when("requiereFactura", {
    is: true,
    then: schema =>
      schema.required("Requerido").positive("Debes elegir una opción"),
    otherwise: schema => schema.notRequired(),
  }),
  usoCfdi: Yup.string().when("requiereFactura", {
    is: true,
    then: schema =>
      schema.required("Este campo es obligatorio cuando se requiere factura"),
    otherwise: schema => schema.notRequired(),
  }),
  ccEmails: Yup.string().when("requiereFactura", {
    is: true,
    then: schema =>
      schema
        .required("El campo es obligatorio cuando se requiere factura")
        .test(
          "ccEmails",
          "Debe ser una lista de correos válidos, separados por comas",
          value => {
            if (!value) return false // ya que es requerido
            // Separamos los correos por comas, eliminando espacios en blanco
            const emails = value
              .split(",")
              .map(email => email.trim())
              .filter(email => email.length > 0)
            // Si no hay correos después de separar, es un error
            if (emails.length === 0) return false
            // Validamos cada correo con una expresión regular básica
            const emailRegex = /\S+@\S+\.\S+/
            return emails.every(email => emailRegex.test(email))
          }
        ),
    otherwise: schema => schema.notRequired(),
  }),
  facturaObservaciones: Yup.string().matches(
    genericoRegex,
    "Solo letras, numeros y un espacio entre palabras"
  ),
})

export const AltaContribuyenteSchema = Yup.object({
  RFC: Yup.string()
    .max(13, "No puede exceder 13 caracteres.")
    .matches(
      RFCRegex,
      "Solo puede contener letras y un espacio entre palabras."
    )
    .required("Requerido"),
  Razon_Social: Yup.string()
    .max(150, "No puede exceder 150 caracteres.")
    .matches(
      nameRegex,
      "Solo puede contener letras y un espacio entre palabras."
    )
    .required("Requerido"),
  Regimen_Fiscal: Yup.string()
    .matches(RegimenFiscalRegex, "Solo puede contener 3 caracteres.")
    .required("Requerido"),
  Codigo_Postal: Yup.string()
    .matches(postalCodeRegex, "Solo puede contener 5 caracteres.")
    .required("Requerido"),
})

export const detallesAlumnoSchema = Yup.object({
  Apellido_Paterno: Yup.string()
    .matches(
      nameRegex,
      "Solo puede contener letras y un espacio entre palabras."
    )
    .required("Requerido"),
  Apellido_Materno: Yup.string().matches(
    nameRegex,
    "Solo puede contener letras y un espacio entre palabras."
  ),
  Nombres: Yup.string()
    .matches(
      nameRegex,
      "Solo puede contener letras y un espacio entre palabras."
    )
    .required("Requerido"),
  Curp: Yup.string()
    .length(18, "Debe tener 18 caracteres.")
    .matches(curpRegex)
    .required("Requerido"),
  Email_Personal: Yup.string()
    .email()
    .matches(emailRegex)
    .required("Requerido"),
  Password: Yup.string()
    .min(6, "La longitud del password debe ser de al menos 6 caracteres.")
    .matches(RegExp("(.*[a-z].*)"), "Al menos una letra minúscula")
    .matches(RegExp("(.*[A-Z].*)"), "Al menos una letra mayúscula")
    .matches(RegExp("(.*[0-9].*)"), "Al menos un número")
    .required("Requerido"),
  Telefono_Celular: Yup.string()
    .matches(
      phoneRegex,
      "El teléfono debe tener exactamente 10 dígitos y solo números."
    )
    .required("Requerido"),
  id_Estado: Yup.number().required("Requerido"),
  id_Pais: Yup.number().required("Requerido"),
  Fecha_Nacimiento: Yup.date().required("Requerido"),
  id_Estado_Civil: Yup.number().required("Requerido"),
})
